<template>
  <section>
    <div class="page-header">
      <div class="d-flex justify-content-between align-items-center">
        <div class="d-flex align-items-center mb-4">
          <back-arrow />
          <h2>Experience Results</h2>
        </div>
        <div class="d-flex align-items-center">
          <h5
            class="cursor-pointer mb-0 mx-4 compare-btn"
            @click="compareSurveys()"
          >
            <img
              src="@/assets/images/charts/compare.svg"
              alt="compare"
              class="img-fluid me-3"
              width="37"
            />
            Compare
          </h5>

          <span
            class="ms-3 v-select-light"
            v-if="getYearsRed && getYearsRed.length"
          >
            <v-select :options="getYearsRed" v-model="year"></v-select>
          </span>

          <span @click="$router.go(-1)"> <close-svg /> </span>
        </div>
      </div>

      <h3 class="container-section-header mb-2" v-if="completedSurveysDataSet">
        {{ completedSurveysDataSet.length }} Individual Scores
      </h3>
    </div>
    <filter-ui>
      <template
        v-slot:filterOptions
        v-if="completedSurveysDataSet && surveyGroupNames.length > 1"
      >
        <h6 class="me-4 mb-0 survey-filter-title">Filter</h6>
        <div
          v-for="(surveyGroupName, index) in surveyGroupNames"
          :key="surveyGroupName + index"
        >
          <input
            class="d-none filter-option"
            type="checkbox"
            :id="'CompletedSurveys-' + surveyGroupName"
            :value="surveyGroupName"
            v-model="selectedSurveyGroupNames"
          />

          <label
            class="me-2 text-capitalize filter-button px-3"
            :for="'CompletedSurveys-' + surveyGroupName"
            >{{ surveyGroupName }} ({{
              noOfSurveysInSurveyGroup(surveyGroupName)
            }})</label
          >
        </div>
      </template>
      <template
        v-slot:clearOption
        v-if="completedSurveysDataSet && surveyGroupNames.length > 1"
      >
        <transition name="fade">
          <div
            v-if="selectedSurveyGroupNames.length > 0"
            @click="selectedSurveyGroupNames = []"
          >
            <clear-button></clear-button>
          </div>
        </transition>
      </template>
    </filter-ui>
    <!-- ./filter  -->

    <div class="row cards-container mt-4" v-if="dataset.length">
      <div
        v-for="(item, index) in filteredSurveys"
        class="col-md-3 col-12"
        :class="[`cardBubble${item.surveyId}`]"
        :key="`cardBubble${item.surveyId}`"
      >
        <CompletedSurveyCard
          :class-card="`cardBubble${item.surveyId}`"
          :dataset="item"
          :index="index"
          type="red"
        />
      </div>
    </div>
    <template v-else>
      <the-loading />
    </template>
  </section>
</template>

<script>
import CompletedSurveyCard from "@/components/dashboard/surveys-cards/completed-survey-card.vue";
import { mapGetters } from "vuex";

export default {
  name: "CompletedSurveys",
  components: {
    CompletedSurveyCard,
  },
  data() {
    return {
      dataset: [],
      selectedSurveyGroupNames: [],
      year: "",
    };
  },
  computed: {
    ...mapGetters("mainStats", {
      completedSurveysDataSet: "getSurveysWithModesDataset",
      getYearsRed: "getYearsRed",
      redSelectedYear: "getRedSelectedYear",
    }),
    filteredSurveys() {
      if (this.selectedSurveyGroupNames.length === 0) return this.dataset;
      return this.dataset.filter(
        (survey) =>
          this.selectedSurveyGroupNames.indexOf(survey.surveyGroupName) >= 0
      );
    },
    surveyGroupNames() {
      return [...this.completedSurveysDataSet]
        .map((item) => item.surveyGroupName)
        .filter((value, index, self) => self.indexOf(value) === index);
    },
  },
  methods: {
    noOfSurveysInSurveyGroup(surveyGroupName) {
      return this.dataset.filter(
        (survey) => survey.surveyGroupName === surveyGroupName
      ).length;
    },
    async loadRedCompletedSurveysInYear() {
      try {
        await this.$store.dispatch("mainStats/loadSurveysWithModes", {
          year: this.year,
        });
      } catch (error) {
        this.$store.dispatch("dialog/showErrorDialog", {
          error: error,
        });
      }
    },
    async compareSurveys() {
      try {
        await this.$store.dispatch("mainStats/loadSurveysOFAllYears", {
          surveyType: "red",
        });
        this.$store.dispatch("mainStats/showSelectSurveys", "red");
      } catch (error) {
        this.$store.dispatch("dialog/showErrorDialog", {
          error: error,
        });
      }
    },
  },
  async mounted() {
    if (!this.getYearsRed) {
      await this.$store.dispatch("mainStats/fetchSurveyTypeYears", {
        surveyType: "RED",
      });
      const currentRedYear = this.getYearsRed[this.getYearsRed.length - 1];
      this.$store.commit("mainStats/setRedSelectedYear", currentRedYear);
    }

    this.year = this.redSelectedYear;
  },
  watch: {
    async year(newval) {
      await this.loadRedCompletedSurveysInYear();
      this.$store.commit("mainStats/setRedSelectedYear", newval);
      this.dataset = this.completedSurveysDataSet;
    },
  },
};
</script>

<style lang="scss" scoped>
.page-header {
  position: relative;
  background: $color-grey-100;
  width: 100%;
}

.cards-container {
  position: relative;
  overflow-x: hidden;
  overflow-y: auto;
  height: calc(100vh - 16.9375rem);
}

.survey-filter-title,
.compare-btn {
  min-width: fit-content;

  img {
    width: 2.3125rem;
  }
}
</style>
